module.exports = __webpack_public_path__ + "static/media/tools.7aed3010.png";